import React from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import EmailPage from "../components/EmailManagement/EmailPage";
import JobList from "../components/EmailManagement/JobList";
import JobDetail from "../components/EmailManagement/JobDetail";

// Email role: send jobs of every channel (?page=list | detail&jobid=)
export default function SendHistory() {
  const [searchParams] = useSearchParams();
  const detail = searchParams.get("page") === "detail";
  const listPath = `/${Cookies.get("mhet_mst_project")}/send-history?page=list`;
  return (
    <EmailPage
      title={detail ? "Send Job" : "Send History"}
      crumbs={detail ? [{ label: "Send History", to: listPath }, { label: `Job ${searchParams.get("jobid")}` }] : [{ label: "Send History" }]}
    >
      {detail ? <JobDetail key={searchParams.get("jobid")} /> : <JobList />}
    </EmailPage>
  );
}
